export const cf7RedirectsAfterSubmit = () => {
  // Redirect after form submit
  document.addEventListener('wpcf7mailsent', function (event) {

    // Function to handle form submission
    function handleFormSubmission(formId) {
      // Loop through the array to find a match
      if (cf7RedirectToArray != undefined && cf7RedirectToArray != null) {
        for (var i = 0; i < cf7RedirectToArray.length; i++) {
          if (cf7RedirectToArray[i].select_form === formId) {
            // Redirect to the corresponding link
            if (cf7RedirectToArray[i].link_to_redirect_after_submit != null && cf7RedirectToArray[i].link_to_redirect_after_submit != undefined) {
              window.location.href = cf7RedirectToArray[i].link_to_redirect_after_submit;
            }
            
            break; // Exit the loop once a match is found
          }
        }
      }
    }
    var formId = event.detail.contactFormId;
    handleFormSubmission(formId);
  }, false);
};
